<!--
  Copyright (C) 2021 owner Roman Piontik R.Piontik@mail.ru

  Copyright (C) 2022 Sber

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

  http://www.apache.org/licenses/LICENSE-2.0

  In any derivative products, you must retain the information of
  owner of the original code and provide clear attribution to the project

  https://dochub.info

  The use of this product or its derivatives for any purpose cannot be a secret.


  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
      R.Piontik <r.piontik@mail.ru>

  Contributors:
      Navasardyan Suren, Sber - 2023
      Rostislav Kabalin <kabalin2009@yandex.ru> - 2022
      R.Piontik <r.piontik@mail.ru> - 2024
      Artyom Prilip <artyom.prilip@gmail.com>, Sber - 2026
-->

<template>
  <box
    v-bind:errors="errors"
    v-bind:path="path"
    v-on:doc-contextmenu="showContextMenu">
    <section ref="asyncApi" class="async-api" />
  </box>
</template>

<script>
  import '@asyncapi/react-component/styles/default.min.css';
  import AsyncApiStandalone from '@asyncapi/react-component/browser/standalone';

  import DocMixin from './DocMixin';
  import { getAsyncApiContext } from '@front/helpers/misc';

  export default {
    name: 'DocAsyncApi',
    mixins: [DocMixin],
    methods: {
      renderRefSection(res) {
        AsyncApiStandalone.render({
          schema: res.data
        }, this.$refs.asyncApi);
      },
      refresh() {
        getAsyncApiContext.call(this);
      }
    }
  };
</script>

<style scoped>
  .async-api {
    width: 100%;
    min-width: 0;
    overflow-x: auto;
  }

  .async-api :deep(.aui-root) {
    width: 100%;
    min-width: 0;
  }

  .async-api :deep(.aui-root .examples) {
    margin-right: 0;
    margin-left: 0;
    padding-right: 1rem;
    padding-left: 1rem;
    border-radius: 0.25rem;
  }

  /*
   * Дефолтные стили AsyncAPI на широких экранах разделяют документацию
   * и примеры на две колонки. В layout DocHub сохраняем одноколоночный режим.
   */
  @media (min-width: 1536px) {
    .async-api :deep(.aui-root .container\:base .panel-item) {
      display: block;
    }

    .async-api :deep(.aui-root .container\:base .panel--center .panel-item--center),
    .async-api :deep(.aui-root .container\:base .panel--center .panel-item--right) {
      width: 100%;
    }

    .async-api :deep(.aui-root .container\:base .examples) {
      margin-top: 1rem;
    }

    .async-api :deep(.aui-root .container\:base .panel--right) {
      display: none;
    }
  }
</style>
